import { render, staticRenderFns } from "./PieChartReserve.vue?vue&type=template&id=6f69b054&"
import script from "./PieChartReserve.vue?vue&type=script&lang=js&"
export * from "./PieChartReserve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/noblecare-backend.mindful-birthing.com.tw/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f69b054')) {
      api.createRecord('6f69b054', component.options)
    } else {
      api.reload('6f69b054', component.options)
    }
    module.hot.accept("./PieChartReserve.vue?vue&type=template&id=6f69b054&", function () {
      api.rerender('6f69b054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/reserve_system_dashboard/components/PieChartReserve.vue"
export default component.exports